import {
    textFieldCharacterWhitelist,
    validateNoExcelFormulaStartingCharacters
} from '@tassat/forms/src/helpers/validationHelpers';
import { Asset } from '@tassat/fred-definitions';
import { AccountBalancesStatsParam } from '@tassat/fred-extended-definitions';
import { convertToNumber } from '@tassat/utility';

import { IFormErrors, IWithdrawalFormValues } from './types';

export const validateWithdrawal = async (
    values: IWithdrawalFormValues,
    opts: {
        errors: IFormErrors;
        dxyObject: Asset;
        accountPositionBalance: AccountBalancesStatsParam;
    }
) => {
    const {
        errors,
        dxyObject,
        accountPositionBalance
    } = opts;

    const privateDescription = values.PrivateDescription.trim();

    const accountUSDPosition = accountPositionBalance[0].ccy[dxyObject.AssetId];
    const withdrawAmt = convertToNumber(values.WithdrawalAmount ?? 0);
    if (!withdrawAmt){
        errors.WithdrawalAmount = 'Required';
    } else if (withdrawAmt > Number(accountUSDPosition?.availableBalance ?? 0)) {
        errors.WithdrawalAmount = `Amount must not exceed the available ${dxyObject.Ticker} balance of the account`;
    }

    if (!values.WithdrawalInstructions.value){
        errors.WithdrawalInstructions = 'Required';
    }

    const privateDescriptionWhitelistError = textFieldCharacterWhitelist(privateDescription);
    const privateDescriptionExcelError = validateNoExcelFormulaStartingCharacters(privateDescription);
    if (privateDescriptionWhitelistError) {
        errors.PrivateDescription = privateDescriptionWhitelistError;
    } else if (privateDescriptionExcelError) {
        errors.PrivateDescription = privateDescriptionExcelError;
    }

    return errors;
};